import React, { useRef, useState } from "react";
import styles from "./Product.module.css";
import SimpleBtn from "../../../components/Button/SimpleBtn";

function Product({ name, description, image }) {
  const product = useRef(null);
  const productDesc = useRef(null);

  function handleMouseMove(e) {
    // console.log(e.currentTarget);

    if (product.current) {
      const { top, height } = e.currentTarget.getBoundingClientRect();
      const { scrollHeight, clientHeight } = productDesc.current;
      const relativeY = e.clientY - top;
      const percent = relativeY / height;

      productDesc.current.scrollTop = percent * (scrollHeight - clientHeight);
    }
  }
  return (
    <div className={`${styles.productCont} product__cont`}>
      <div
        className={`${styles.product} `}
        onMouseMove={handleMouseMove}
        ref={product}>
        <div className={styles.productHead}>
          <h3>{name}</h3>
          <img src={image} alt="" />
        </div>
        <div className={`${styles.productDesc}`} ref={productDesc}>
          <p>{description}</p>
          <SimpleBtn
            className={styles.productMoreBtn}
            link={`/Product/${name}`}>
            اطلاعات بیشتر
          </SimpleBtn>
        </div>
      </div>
    </div>
  );
}

export default Product;
